import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import LandingV3 from "@/pages/LandingV3";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import Cookies from "@/pages/Cookies";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Assessment from "@/pages/Assessment";

function AppRouter() {
    const location = useLocation();
    // Synchronous check for the Emergent OAuth return (session_id in URL fragment).
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<LandingV3 />} />
            <Route path="/v3" element={<Navigate to="/" replace />} />
            <Route path="/v1" element={<Landing />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/contact" element={<Contact />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App font-sans bg-aq-cream text-aq-charcoal min-h-screen">
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
            <Toaster richColors position="top-center" />
        </div>
    );
}

export default App;
